import {
  observer,
  useLocation,
  useTranslation,
  Navigate,
  Spin,
  Routes,
  Route,
} from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 88504, offsets 273562:281609. Structure and names inferred from code, not screenshots.
import * as dependency78493 from "../recovered/style-marker-78493.js";
import * as jsxRuntime from "react/jsx-runtime";
import * as React from "react";
import * as AnnouncementModule from "../components/Announcement.jsx";
import * as GetLanguageModule from "../i18n/getLanguage.js";
import * as LocalizedPathsModule from "./localizedPaths.js";
import * as LocaleContext from "../i18n/I18nProvider.jsx";
import * as TestDocumentsModule from "./testDocuments.js";
import * as AgreementPageModule from "./AgreementPage.jsx";
import { module33577 as h } from "../vendor/dependencies.js";
import * as SiteState from "../state/siteStore.js";
import * as IconModule from "../components/Icon.jsx";
import * as PageKindModule from "./pageKind.js";
import * as LanguageToggleModule from "../components/LanguageToggle.jsx";
import * as DocNavItemModule from "../components/DocNavItem.jsx";
import * as DocSearchModule from "../components/DocSearch.jsx";
import * as DocumentEventsModule from "./documentEvents.js";
import { loadArchivedChunk, loadArchivedModule } from "../vendor/runtime.js";
dependency78493;
let y = "/test-docs",
  x = [],
  N = Array.isArray(x) && x.length > 0;
!N &&
  "u" > typeof console &&
  console.warn(
    "[test-docs] visual-test-documents.json 为空，使用最小回退。请检查 CI 是否错误执行 pre-build，或 doc-settings.visual-test.json 是否缺失节点。",
  );
let b = N
  ? x
  : [
      {
        key: "E2E-TEST1",
        titleZh: "E2E-TEST1",
        titleEn: "E2E-TEST1",
        href: "/e2e1",
      },
    ];
function k(e) {
  let t = `/${e.replace(/^\/+/u, "").replace(/\/+$/u, "")}`,
    i = (function e(i, n) {
      for (let o of i) {
        if ("spacer" in o) continue;
        let i = o.href ? `${n}${o.href}` : n;
        if (i === t)
          return {
            node: o,
            fullPath: n,
          };
        if (o.items) {
          let t = e(o.items, i);
          if (t) return t;
        }
      }
      return null;
    })(b, "");
  if (!i) return null;
  let { node: node, fullPath: fullPath } = i;
  return node.items && node.items.length > 0
    ? (function e(t, i) {
        if ("spacer" in t) return null;
        let n = t.href ? `${i}${t.href}` : i;
        if (t.items && t.items.length > 0) {
          for (let i of t.items) {
            let t = e(i, n);
            if (t) return t;
          }
          return null;
        }
        return t.href && !t.noLink ? n : null;
      })(node, fullPath)
    : null;
}
function T(e, t = "", i = "/test-docs") {
  let n = [];
  for (let o of e) {
    if ("spacer" in o || !("key" in o)) continue;
    let e = o.href,
      a = t;
    if (o.agreementFullPath) {
      let e = String(o.agreementFullPath).replace(/^\/+/u, "");
      ((a = e ? `${y}/${e}` : y), n.push(a));
    } else e && ((a = t ? `${t}${e}` : `${i}${e}`), n.push(a));
    o.items?.length && n.push(...T(o.items, a, i));
  }
  return n;
}
b.flatMap((e) =>
  (function e(t) {
    let i = [];
    if (
      ("key" in t &&
        t.href &&
        !t.noLink &&
        i.push({
          key: t.key,
          href: t.href,
        }),
      "key" in t && t.items)
    )
      for (let n of t.items) i.push(...e(n));
    return i;
  })(e),
);
let Component = observer(({ isSheet: e = false }) => {
    let { pathname: pathname } = useLocation(),
      { language: language } = (0, LocaleContext.useI18n)(),
      r = (0, React.useRef)(null),
      l = (function (e, t = "zh") {
        let i = (0, LocalizedPathsModule.$C)(e).replace(/\/$/, "") || e,
          n = (0, LocalizedPathsModule.Qe)(e, t);
        for (let e of b.filter((e) => "key" in e && !("spacer" in e)))
          if (e.items) {
            let t = T(e.items, "", n);
            if (
              (e.href && t.push(`${n}${e.href}`),
              t.some((e) => i === e || i.startsWith(`${e}/`)))
            )
              return e;
          } else if (e.href) {
            let t = `${n}${e.href}`;
            if (i === t || i.startsWith(`${t}/`)) return e;
          }
        return null;
      })(pathname, language),
      s = l?.items ?? [];
    return ((0, React.useLayoutEffect)(() => {
      if (!pathname.startsWith("/test-docs") || (0, DocumentEventsModule.Z)())
        return;
      let e = (function (e, t = "zh") {
          let i = (0, LocalizedPathsModule.$C)(e).replace(/\/$/, "") || e,
            n = [
              ...new Set(T(b, "", (0, LocalizedPathsModule.Qe)(e, t))),
            ].filter((e) => i === e);
          if (0 === n.length) return null;
          let o = n[0];
          for (let e = 1; e < n.length; e++) {
            let t = n[e];
            t.length > o.length && (o = t);
          }
          return o;
        })(pathname, language),
        n = r.current;
      if (!e || !n) return;
      let o =
          "u" > typeof CSS && "function" == typeof CSS.escape
            ? CSS.escape(e)
            : e.replaceAll('"', '\\"'),
        a = n.querySelector(`[data-doc-nav-href="${o}"]`);
      a &&
        (function (e, t, i = "smooth") {
          let n = t.getBoundingClientRect().top - e.getBoundingClientRect().top,
            o = e.scrollTop + n;
          e.scrollTo({
            top: Math.max(0, o),
            behavior: i,
          });
        })(n, a, "auto");
    }, [pathname]),
    pathname.startsWith("/test-docs")) ? (
      <div
        className={`flex-1 flex flex-col items-start justify-between w-full h-full pt-[16px] pl-[24px] ${(0, PageKindModule.usesPageBackground)(pathname) ? "bg-[var(--color-bg-page)]" : "bg-white"}`}
      >
        <div className={"pb-[12px] w-full"}>
          <DocSearchModule.DocSearch />
        </div>
        <div
          ref={r}
          className={
            "flex flex-col items-start overflow-auto py-0 sticky top-0 w-full flex-1"
          }
        >
          <div className={"flex flex-col gap-px items-start w-full"}>
            {s.map((o) => {
              if ("spacer" in o) return null;
              let { key: key, ...r } = o,
                s = (0, LocalizedPathsModule.Qe)(pathname, language),
                d = l?.href ? `${s}${l.href}` : s,
                u =
                  "agreementFullPath" in r && r.agreementFullPath
                    ? String(r.agreementFullPath).replace(/^\/+/u, "")
                    : "",
                p = r.href
                  ? u
                    ? `/test-docs/${u}`
                    : `${d}${r.href}`
                  : undefined;
              return (
                <DocNavItemModule.DocNavItem
                  key={key}
                  {...r}
                  href={p}
                  level={0}
                  isSheet={e}
                />
              );
            })}
          </div>
        </div>
        <div className={"pb-[18px] w-full"}>
          <LanguageToggleModule.LanguageToggle />
        </div>
      </div>
    ) : null;
  }),
  I = observer(() => {
    let { showBanner: showBanner, docsSidebarCollapsed: docsSidebarCollapsed } =
        SiteState.siteStore,
      { t: translate } = useTranslation(),
      { pathname: pathname } = useLocation(),
      r = 54;
    return (
      pathname.includes("/test-docs/") && (r += 47),
      showBanner && (r += 40),
      (
        <jsxRuntime.Fragment>
          <aside
            className={`sticky top-0 hidden overflow-x-hidden flex-col overflow-y-auto lg:flex shrink-0 min-h-min transition-[width] duration-300 ease-in-out motion-reduce:transition-none ${docsSidebarCollapsed ? "w-0" : "w-[250px]"}`}
            aria-label={"Page navigation"}
            aria-hidden={docsSidebarCollapsed}
            style={{
              height: `calc(100vh - ${r}px)`,
            }}
          >
            <Component />
          </aside>
          <h.A title={translate("sidebar.toggle.expand")} placement={"right"}>
            <button
              type={"button"}
              className={
                "absolute hidden lg:flex rounded-[6px] shadow-[0_8px_24px_rgba(0,0,0,0.08)] items-center justify-center top-5 left-[18px] transition-opacity duration-300"
              }
              style={{
                opacity: +!!docsSidebarCollapsed,
                pointerEvents: docsSidebarCollapsed ? "auto" : "none",
              }}
              onClick={() => SiteState.siteStore.toggleDocsSidebarCollapsed()}
            >
              <IconModule.Icon
                icon={"menu-open"}
                size={24}
                style={{
                  padding: "4px",
                }}
              />
            </button>
          </h.A>
        </jsxRuntime.Fragment>
      )
    );
  }),
  testDocumentCache = {},
  S = TestDocumentsModule.testDocuments.map(
    ({ path: path, importFn: importFn, key: key }) => {
      let Component3;
      return {
        path: path,
        component:
          ((Component3 = (0, React.lazy)(
            () => (
              testDocumentCache[key]?.promise ||
                (testDocumentCache[key] = {
                  ...testDocumentCache[key],
                  promise: importFn().then(
                    (e) => ((testDocumentCache[key].component = e.default), e),
                  ),
                }),
              testDocumentCache[key].promise
            ),
          )),
          function (e) {
            let Component2 = testDocumentCache[key]?.component;
            return Component2 ? <Component2 {...e} /> : <Component3 {...e} />;
          }),
      };
    },
  ),
  z = ["development", "review", "preview", "staging"].includes("production"),
  L = (0, React.lazy)(() =>
    Promise.all([
      loadArchivedChunk(2374),
      loadArchivedChunk(2422),
      loadArchivedChunk(4243),
      loadArchivedChunk(9832),
      loadArchivedChunk(9225),
    ]).then(() => loadArchivedModule(29559)),
  ),
  E = new Set([]);
function O() {
  return (
    <Navigate
      to={(0, LocalizedPathsModule.am)(
        (0, LocalizedPathsModule.Oz)((0, GetLanguageModule.getLanguage)()),
        "",
        "/test-docs",
      )}
      replace={true}
    />
  );
}
function U() {
  let { pathname: pathname, search: search, hash: hash } = useLocation(),
    a = pathname.replace(/^\/test-docs\/?/u, "").replace(/\/$/u, "");
  if (!a) return <O />;
  if ("chrome-plugin" === a || a.startsWith("chrome-plugin/"))
    return (
      <Navigate
        to={`/test-docs/chrome-plugin${search}${hash}`}
        replace={true}
      />
    );
  if (a.startsWith("zh-CN/")) {
    let e = a.slice(6);
    if (e && E.has(e))
      return <Navigate to={`/test-docs/${e}${search}${hash}`} replace={true} />;
  }
  if (a.startsWith("en-US/")) {
    let e = a.slice(6);
    if (e && E.has(e))
      return <Navigate to={`/test-docs/${e}${search}${hash}`} replace={true} />;
  }
  for (let e of ["zh-CN", "en-US"])
    if (a === e || a.startsWith(`${e}/`)) {
      let r = a === e ? "" : a.slice(e.length + 1);
      if (r) {
        let a = k(r);
        if (a)
          return (
            <Navigate
              to={`/test-docs/${e}${a}${search}${hash}`}
              replace={true}
            />
          );
      }
      return (
        <Navigate to={`/test-docs/${e}/e2e1${search}${hash}`} replace={true} />
      );
    }
  {
    let e = k(a);
    if (e) {
      let a = (0, LocalizedPathsModule.Oz)(
        (0, GetLanguageModule.getLanguage)(),
      );
      return (
        <Navigate to={`/test-docs/${a}${e}${search}${hash}`} replace={true} />
      );
    }
  }
  let r = (0, LocalizedPathsModule.Oz)((0, GetLanguageModule.getLanguage)());
  return (
    <Navigate to={`/test-docs/${r}/${a}${search}${hash}`} replace={true} />
  );
}
function TestDocumentRoutes() {
  let e = useLocation(),
    { language: language, setLanguage: setLanguage } = (0,
    LocaleContext.useI18n)();
  return (
    (0, React.useEffect)(() => {
      let n = (0, LocalizedPathsModule.EH)(e.pathname);
      if (null != n) {
        if (n !== language) return void setLanguage(n);
        try {
          localStorage.getItem("user_language_preference") !== n &&
            localStorage.setItem("user_language_preference", n);
        } catch {}
      }
    }, [e.pathname, language, setLanguage]),
    (0, React.useEffect)(() => {
      let e = document.querySelector("main");
      e &&
        e.scrollTo({
          top: 0,
          behavior: "auto",
        });
    }, [e.pathname]),
    (0, React.useEffect)(() => {
      let e = async () => {
        for (let e = 0; e < TestDocumentsModule.testDocuments.length; e += 5) {
          let t = TestDocumentsModule.testDocuments.slice(e, e + 5);
          (await Promise.allSettled(
            t.map(
              ({ importFn: importFn, key: key }) => (
                testDocumentCache[key]?.promise ||
                  (testDocumentCache[key] = {
                    promise: importFn().then(
                      (e) => (
                        (testDocumentCache[key].component = e.default),
                        e
                      ),
                    ),
                  }),
                testDocumentCache[key].promise
              ),
            ),
          ),
            await new Promise((e) => {
              setTimeout(e, 100);
            }));
        }
      };
      "requestIdleCallback" in window
        ? window.requestIdleCallback(() => {
            setTimeout(e, 500);
          })
        : setTimeout(e, 2e3);
    }, []),
    (
      <jsxRuntime.Fragment>
        <AnnouncementModule.Announcement />
        <div
          className={
            "relative flex flex-1 flex-shrink-0 items-start flex-start w-full max-w-[1440px] mx-auto"
          }
        >
          {!e.pathname.includes("chrome-plugin") && <I />}
          <React.Suspense
            fallback={
              <div className={"flex-1 flex justify-center pt-20"}>
                <Spin spinning={true} />
              </div>
            }
          >
            <Routes>
              <Route index={true} element={<O />} />
              {z && <Route path={"chrome-plugin"} element={<L />} />}
              {S.map(({ path: path, component: component }) => (
                <Route key={path} path={path} element={<component />} />
              ))}
              {TestDocumentsModule.vg.flatMap((e) => [
                <Route
                  key={`z-${e.fromPrefix}`}
                  path={`zh-CN/${e.fromPrefix}/*`}
                  element={
                    <AgreementPageModule.AgreementPage
                      fromPrefix={e.fromPrefix}
                      toPrefix={e.toPrefix}
                    />
                  }
                />,
                <Route
                  key={`e-${e.fromPrefix}`}
                  path={`en-US/${e.fromPrefix}/*`}
                  element={
                    <AgreementPageModule.AgreementPage
                      fromPrefix={e.fromPrefix}
                      toPrefix={e.toPrefix}
                    />
                  }
                />,
                <Route
                  key={`u-${e.fromPrefix}`}
                  path={`${e.fromPrefix}/*`}
                  element={
                    <AgreementPageModule.AgreementPage
                      fromPrefix={e.fromPrefix}
                      toPrefix={e.toPrefix}
                    />
                  }
                />,
              ])}
              <Route path={"*"} element={<U />} />
            </Routes>
          </React.Suspense>
        </div>
      </jsxRuntime.Fragment>
    )
  );
}
export { testDocumentCache, TestDocumentRoutes };
